/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetRfidListPathParameters } from 'api/actions/get-rfid-list/get-rfid-list-path-parameters';
import { GetRfidListResponse } from 'api/actions/get-rfid-list/get-rfid-list-response';

type GetRfidListQueryParameters = Record<string, any>;

/**
 * The path of the GetRfidList action.
 */
export const getRfidListActionPath = new SweetPath<keyof GetRfidListPathParameters>('/rfid/list', { path: '{param}' });

/**
 * Creates a contextualized GetRfidList actions.
 */
export default function createGetRfidListAction(axios: AxiosInstance) {
  return function getRfidListAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: GetRfidListQueryParameters } = {}) {
    const path = getRfidListActionPath.original;

    return axios.get<GetRfidListResponse, GetRfidListResponse>(path, { params: query, headers });
  };
}
